import { query } from '@/services/down/apilog';

export default {
  namespace: 'apilog',
  state: {
    data: {
      dataSource: [],
      pagination: {},
    },
  },

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
      if (response.success) {
        yield put({
          type: 'success',
          payload: {
            dataSource: response.data.records,
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              more: response.data.paging.more,
            },
          },
        });
      }
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
  },
};
